import gql from "graphql-tag";

export const GET_CATEGORY_WISE_OPPORTUNITY = gql`
    query($limit: Int!, $offset: Int!, $client_id: uuid, $search: String) {
        spendmd_db_category_wise_opportunity(
            order_by: { created_at: desc }
            where: {
                client_id: { _eq: $client_id }
                goal_name: { _ilike: $search }
            }
            limit: $limit
            offset: $offset
        ) {
            goal
            goal_name
            created_at
            opportunity
            vendor_name
            id
            prime_category
            category
            sub_category
            prime_category_master {
                name
            }
            sub_category_master {
                name
            }
            category_master {
                name
            }
            client {
                name
            }
            client_id
        }
        spendmd_db_category_wise_opportunity_aggregate(
            where: {
                client_id: { _eq: $client_id }
                goal_name: { _ilike: $search }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`;

export const INSERT_CATEGORY_WISE_OPPORTUNITY = gql`
    mutation(
        $category: Int
        $goal: numeric!
        $goal_name: String!
        $opportunity: numeric!
        $prime_category: Int!
        $sub_category: Int
        $vendor_name: String
        $client_id: uuid!
        $created_at: date!
    ) {
        insert_spendmd_db_category_wise_opportunity(
            objects: {
                category: $category
                goal: $goal
                goal_name: $goal_name
                opportunity: $opportunity
                prime_category: $prime_category
                sub_category: $sub_category
                vendor_name: $vendor_name
                client_id: $client_id
                created_at: $created_at
            }
        ) {
            returning {
                id
                prime_category_master {
                    name
                }
                sub_category_master {
                    name
                }
                category_master {
                    name
                }
            }
        }
    }
`;

export const UPDATE_CATEGORY_WISE_OPPORTUNITY = gql`
    mutation(
        $id: Int!
        $category: Int
        $goal: numeric!
        $goal_name: String!
        $opportunity: numeric!
        $prime_category: Int!
        $sub_category: Int
        $vendor_name: String
        $client_id: uuid!
        $created_at: date!
    ) {
        update_spendmd_db_category_wise_opportunity(
            where: { id: { _eq: $id } }
            _set: {
                category: $category
                goal: $goal
                goal_name: $goal_name
                opportunity: $opportunity
                prime_category: $prime_category
                sub_category: $sub_category
                vendor_name: $vendor_name
                client_id: $client_id
                created_at: $created_at
            }
        ) {
            returning {
                id
                prime_category_master {
                    name
                }
                sub_category_master {
                    name
                }
                category_master {
                    name
                }
            }
        }
    }
`;

export const DELETE_CATEGORY_WISE_OPPORTUITY = gql`
    mutation($id: Int!) {
        delete_spendmd_db_category_wise_opportunity(
            where: { id: { _eq: $id } }
        ) {
            returning {
                id
            }
        }
    }
`;

export const GET_PRIME_CATEGORY = gql`
    query($id: Int!) {
        spendmd_db_prime_category_master(where: { id: { _eq: $id } }) {
            alias
            description
        }
    }
`;

export const GET_CATEGORY = gql`
    query($id: Int!) {
        spendmd_db_category_master(where: { id: { _eq: $id } }) {
            description
            alias
        }
    }
`;

export const GET_SUB_CATEGORY = gql`
    query($id: Int) {
        spendmd_db_sub_category_master(where: { id: { _eq: $id } }) {
            description
            alias
        }
    }
`;

// Prime
export const INSERT_PRIME_CATEGORY_OVERRIDE = gql`
    mutation($alias: String!, $client_id: uuid!, $parent_id: Int!) {
        insert_spendmd_db_overrided_prime_category(
            objects: {
                overrided_name: $alias
                client_id: $client_id
                prime_category_id: $parent_id
            }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_PRIME_CATEGORY_OVERRIDE = gql`
    mutation($alias: String!, $id: Int!) {
        update_spendmd_db_overrided_prime_category(
            where: { id: { _eq: $id } }
            _set: { overrided_name: $alias }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_PRIME_CATEGORY_DESCRIPTION = gql`
    mutation($description: String!, $id: Int!) {
        update_spendmd_db_prime_category_master(
            where: { id: { _eq: $id } }
            _set: { description: $description }
        ) {
            returning {
                id
            }
        }
    }
`;

// Category
export const INSERT_CATEGORY_OVERRIDE = gql`
    mutation($alias: String!, $client_id: uuid!, $parent_id: Int!) {
        insert_spendmd_db_overrided_secondary_category(
            objects: {
                overrided_name: $alias
                client_id: $client_id
                secondary_category_id: $parent_id
            }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_CATEGORY_OVERRIDE = gql`
    mutation($alias: String!, $id: Int!) {
        update_spendmd_db_overrided_secondary_category(
            where: { id: { _eq: $id } }
            _set: { overrided_name: $alias }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_CATEGORY_DESCRIPTION = gql`
    mutation($description: String!, $id: Int!) {
        update_spendmd_db_category_master(
            objects: { description: $description }
        ) {
            returning {
                id
            }
        }
    }
`;

// Sub
export const INSERT_SUB_CATEGORY_OVERRIDE = gql`
    mutation($alias: String!, $client_id: uuid!, $parent_id: Int!) {
        insert_spendmd_db_overrided_sub_category(
            objects: {
                overrided_name: $alias
                client_id: $client_id
                sub_category_id: $parent_id
            }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_SUB_CATEGORY_OVERRIDE = gql`
    mutation($alias: String!, $id: Int!) {
        update_spendmd_db_overrided_sub_category(
            where: { id: { _eq: $id } }
            _set: { overrided_name: $alias }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_SUB_CATEGORY_DESCRIPTION = gql`
    mutation($description: String!, $id: Int!) {
        update_spendmd_db_sub_category_master(
            where: { id: { _eq: $id } }
            _set: { description: $description }
        ) {
            returning {
                id
            }
        }
    }
`;

export const GET_VENDOR_ID_BASEDON_ONE_CATEGORIES = gql`
    query($prime_category: Int!) {
        spendmd_db_vendor_category_allocation(
            where: { prime_category: { _eq: $prime_category } }
        ) {
            vendor_id
        }
    }
`;

export const GET_VENDOR_ID_BASEDON_TWO_CATEGORIES = gql`
    query($prime_category: Int!, $category: Int) {
        spendmd_db_vendor_category_allocation(
            where: {
                prime_category: { _eq: $prime_category }
                secondary_category: { _eq: $category }
            }
        ) {
            vendor_id
        }
    }
`;

export const GET_VENDOR_ID_BASEDON_THREE_CATEGORIES = gql`
    query($prime_category: Int!, $category: Int, $sub_category: Int) {
        spendmd_db_vendor_category_allocation(
            where: {
                prime_category: { _eq: $prime_category }
                secondary_category: { _eq: $category }
                sub_category: { _eq: $sub_category }
            }
        ) {
            vendor_id
        }
    }
`;

export const GET_VENDOR_DATA = gql`
    query($vendor_id: Int!) {
        spendmd_db_vendor_master(where: { id: { _eq: $vendor_id } }) {
            vendor_name
        }
    }
`;
